import { Box, TextField } from '@mui/material';
import './profile.css'
import React from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import { Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux'
import Loader from '../../Components/Loader';
import MessageBox from '../../Components/MessageBox';
import { detailsUser, updateUserProfile } from '../../store/actions/userActions';
import { USER_UPDATE_PROFILE_RESET } from '../../constants/userConstants';
function ProfileScreen() {
    const [name, setName] = useState('')
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [confirmPassword, setConfirmPassword] = useState('')
    const dispatch = useDispatch()
    const userSignin = useSelector(state => state.userSignin)
    const { userInfo } = userSignin;
    const userDetails = useSelector(state => state.userDetails);
    const { error, loading, user } = userDetails;

    const userUpdateProfile = useSelector(state => state.userUpdateProfile);

    const { error: errorUpdate, loading: loadingUpdate, success: successUpdate } = userUpdateProfile;

    useEffect(() => {
        if (!user) {
            dispatch({ type: USER_UPDATE_PROFILE_RESET })
            dispatch(detailsUser(userInfo._id))
        } else {
            setName(user.name);
            setEmail(user.email)
        }
    }, [dispatch, userInfo._id, user])

    const submitHandler = (e) => {
        e.preventDefault()

        if (password !== confirmPassword) {
            alert('Password does not match')
        } else {
            dispatch(updateUserProfile({ userId: user._id, name, email, password }))
        }
    }
    return (
        <>
            <div className="imageOverlayContainerProfile">
                <h1>User Profile</h1>
                <div className="colorOverlayProfile"></div>
            </div>

            <div className="signinContainer container-fluid my-5 container">
                {loading ? <Loader></Loader> :
                    error ? <MessageBox variant="danger">{error}</MessageBox> :
                        <>
                            {errorUpdate && <MessageBox variant="danger">{errorUpdate}</MessageBox>}
                            {successUpdate && <MessageBox variant="success">Profile Updated Successfully</MessageBox>}
                            {loadingUpdate ? <Loader></Loader> :
                            <form action="" onSubmit={submitHandler}>
                                <div className="loginFields d-flex justify-content-center">
                                    <Box sx={{ display: "flex", flexWrap: "wrap" }}>
                                        <div>
                                            <TextField
                                                id="outlined-basic"
                                                label="Name"
                                                variant="outlined"
                                                value={name}
                                                onChange={(e) => setName(e.target.value)}
                                                sx={{ mt: 2, width: "30ch" }}
                                            />{" "}
                                            <br />
                                            <TextField
                                                id="outlined-basic_2"
                                                label="Email"
                                                variant="outlined"
                                                value={email}
                                                onChange={(e) => setEmail(e.target.value)}
                                                sx={{ mt: 2, width: "30ch" }}
                                            />{" "}
                                            <br />
                                            <TextField
                                                id="outlined-password-input"
                                                label="Password"
                                                type="password"
                                                value={password}
                                                autoComplete="current-password"
                                                sx={{ mt: 2, width: "30ch" }}
                                                onChange={(e) => setPassword(e.target.value)}
                                            />
                                            <br />
                                            <TextField
                                                id="outlined-password-input_2"
                                                label="Confirm Password"
                                                type="password"
                                                value={confirmPassword}
                                                autoComplete="current-password"
                                                sx={{ mt: 2, width: "30ch" }}
                                                onChange={(e) => setConfirmPassword(e.target.value)}
                                            />
                                            <div className="signinButton d-flex justify-content-center mt-4">
                                                <Button
                                                    type="submit"
                                                    variant="contained"
                                                    className="w-100 bg-warning text-dark"
                                                >
                                                    Update
                                                </Button>
                                            </div>
                                        </div>
                                    </Box>
                                </div>
                            </form> }
                        </>
                }
            </div>
        </>
    )
}

export default ProfileScreen;
